import { API } from '~apis/axios/instance';
import { ResponseBaseWithData } from '~types/response';

/** 파트너 초대 생성 요청 */
export interface CreatePartnerInvitationRequest {
  partnerEmail: string;
}

/** 파트너 초대 응답 */
export interface PartnerInvitationResponse {
  id: number;
  partnerEmail: string;
  createdAt: string;
}

/** 파트너 초대 생성 */
export const createPartnerInvitation = (
  companyId: string,
  request: CreatePartnerInvitationRequest,
) => {
  return API.post<ResponseBaseWithData<PartnerInvitationResponse>>(
    `/api/v3/companies/${companyId}/partner-invitations`,
    { data: request },
  );
};
